import React from 'react';
import ResumeSinceSubSection from './ResumeSinceSubSection';
import ResumeGroupListSubSection from "./ResumeGroupListSubSection";
import ResumeListSubSection from "./ResumeListSubSection";

class ResumeSection extends React.Component {

    constructor(props) {
        super();
    }

    getContents(subsect) {
        if(subsect.type === "since") {
            return <ResumeSinceSubSection data={subsect} currStyles={this.props.currStyles} />
        } else if(subsect.type === "groupedlist"){
            return <ResumeGroupListSubSection data={subsect} currStyles={this.props.currStyles} />
        } else if(subsect.type === "list"){
            return <ResumeListSubSection data={subsect} currStyles={this.props.currStyles} />
        } else {
            return "<section><p>Unrecognized Section Type</p></section>"
        }
    }

    render() {

        return (
            <section style={this.props.currStyles.Body.Section}>
                <p style={this.props.currStyles.Body.Section.title}>{this.props.data.title}</p>
                {this.props.data.subsections.map((subsect) =>
                    this.getContents(subsect)
                )}
            </section>
        );
    }
}

export default ResumeSection


// WEBPACK FOOTER //
// src/ResumeAndDocs/ResumeSection.js